import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageWrapper from "./PageWrapper";
import { useQuizContext } from "./QuizContext";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import "./SignupCommon.css";

const SignupPage9: React.FC = () => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  const handleOptionClick = (option: string) => {
    setSelectedOptions((prevSelectedOptions) => {
      if (option === "None of the above") {
        return [option];
      }

      if (prevSelectedOptions.includes("None of the above")) {
        return prevSelectedOptions
          .filter((item) => item !== "None of the above")
          .concat(option);
      }

      if (prevSelectedOptions.includes(option)) {
        return prevSelectedOptions.filter((item) => item !== option);
      }

      return [...prevSelectedOptions, option];
    });
  };

  const handleNext = () => {
    if (selectedOptions.length > 0) {
      const selectedOptionsString = JSON.stringify(selectedOptions);

      localStorage.setItem(
        "previous_weight_loss_method",
        JSON.stringify({
          key: "previous_weight_loss_method",
          value: selectedOptions, 
          id: 18026059,
        })
      );
      localStorage.setItem("step-5-completed", "true");
    }
  };

  useEffect(() => {
    const savedPreviousWeightLossMethod = localStorage.getItem(
      "previous_weight_loss_method"
    );

    if (savedPreviousWeightLossMethod) {
      const parsedPreviousWeightLossMethod = JSON.parse(
        savedPreviousWeightLossMethod
      );
      setSelectedOptions(parsedPreviousWeightLossMethod.value || []);
    }
  }, []);
  const navigate = useNavigate();

  useEffect(() => {
    const step4Completed = localStorage.getItem("step-4-completed");
    if (step4Completed) {
      navigate("/getting-started/step-5", { replace: true });
    } else {
      navigate("/getting-started/step-4", { replace: true });
    }
  }, []);

  const options = [
    "Exercise",
    "Dieting",
    "Weight loss supplements",
    "Medical weight loss program",
    "None of the above",
  ];

  const step = 5;

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={50} step={step} />
        <div className="signup-content">
          <p className="signup-intro">
            What weight loss methods have you tried in the past?
          </p>
          <p className="signup-intro-para-second">
            Your past can tell us a lot about how we build your future.
          </p>
          <div className="options">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOptions.includes(option) ? "selected" : ""}
                onClick={() => handleOptionClick(option)} 
              >
                {option}
              </label>
            ))}
          </div>
          <Link to="/getting-started/step-6">
            <button
              className="next-btn sticky-btn"
              onClick={handleNext}
              disabled={selectedOptions.length === 0}
            >
              Continue →
            </button>
          </Link>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SignupPage9;
